import { render, staticRenderFns } from "./CustomDialog.vue?vue&type=template&id=5e8cb09b&scoped=true"
import script from "./CustomDialog.vue?vue&type=script&lang=js"
export * from "./CustomDialog.vue?vue&type=script&lang=js"
import style0 from "./CustomDialog.vue?vue&type=style&index=0&id=5e8cb09b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8cb09b",
  null
  
)

export default component.exports